module.exports = {"HomeUrl":"http://www.starcellservicio.com/#","m":{"site":"#1D56A5","logo":"https://yf-files.oss-cn-hongkong.aliyuncs.com/logo/startcell-logo.jpg"},"p":{"site":"#1D56A5","logo":"https://yf-files.oss-cn-hongkong.aliyuncs.com/logo/startcell-logo.jpg","headerBg":"#ffffff","headerColor":"#222222","projectName":"Warranty Check","search_placeholder":"Por favor introduzca tu IMEI"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/appConfigs/starcell.json
// module id = 1Xdb
// module chunks = 1